__turbopack_context__.v({
  "megaMenu": "CustomPictureNav-module__PUW8BG__megaMenu",
});
